import { render } from "./ServiceList.vue?vue&type=template&id=f03721ce"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
script.render = render

export default script